<template>
  <div class="equipment headFixed">
    <div class="fixed_head eqHead equipmentHead">
      <div class="left drop"><span class="icon-drop" @click="dropToggle" key="drop">设备类型</span></div>
      <div class="left drop dropScen"><span class="icon-drop" @click="dropToggleScen" key="drop">场景</span></div>
      <span class="right icon-add" @click="showSheet"></span>
    </div>
    <div class="loadMoreWrapper">
      <div class="headSwiper"></div>
      <mt-swipe :auto="4000" class="banner_swiper">
        <mt-swipe-item class="swipe01">
          <p class="p2"></p>
          <p class="p1">智能家居,改变我们的生活品质</p>
        </mt-swipe-item>
      </mt-swipe>
      <div class="container" infinite-scroll-disabled="loading"
           infinite-scroll-distance="10">
        <div class="list">
          <div class="item eqItem ui-border" v-for="(data, index) in list" :key="data.id">
            <div @click="goDetail(data)">
              <span v-if="data.deviceType === 1" class="eq_icon eq_icon_1"></span>
              <span v-else-if="data.deviceType === 3" class="eq_icon eq_icon_2"></span>
              <span v-else-if="data.deviceType === 2  " class="eq_icon eq_icon_3"></span>
              <span v-else-if="data.deviceType === 5  " class="eq_icon eq_icon_5"></span>
              <span v-else class="icon_2"></span>
              <div class="clear itemTop">
                <!--                                    设备名称-->
                <p class="fs15 left">{{ data.name }}</p>
                <!--                                   设备模式-->
                <div v-if="data.deviceType === 1 && data.airCondition">
                  <span v-if="data.airCondition.setMode === '1'" class="eqModeIcon eqModeIcon_cold"></span>
                  <span v-if="data.airCondition.setMode === '2'" class="eqModeIcon eqModeIcon_hot"></span>
                  <span v-if="data.airCondition.setMode === '0'" class="eqModeIcon eqModeIcon_fan"></span>
                  <router-link :to="'/fault/' + data.iotDeviceId" class="eqAlarm left">
                    <span v-if="data.airCondition.faultInd != null && data.airCondition.faultInd != 0" class="icon-warn"
                          @click.stop="handleLinkClick"></span>
                  </router-link>
                </div>
                <div v-else-if="data.deviceType ===2 && data.airVentilator">
                  <span v-if="data.airVentilator.workingMode1 === '0'" class="eqModeIcon eqModeIcon_cold"></span>
                  <span v-if="data.airVentilator.workingMode1 === '1'" class="eqModeIcon eqModeIcon_hot"></span>
                  <span v-if="data.airVentilator.workingMode1 === '2'" class="eqModeIcon eqModeIcon_fan"></span>
                  <router-link :to="'/fault/' + data.iotDeviceId" class="eqAlarm left">
                    <span v-if="data.airVentilator.totalFaults != null && data.airVentilator.totalFaults != 0"
                          class="icon-warn" @click.stop="handleLinkClick"></span>
                  </router-link>
                </div>
                <div v-else-if="data.deviceType === 3 && data.fanCoil">
                  <span v-if="data.fanCoil.status === 1" class="eqModeIcon eqModeIcon_cold"></span>
                  <span v-if="data.fanCoil.status === 2" class="eqModeIcon eqModeIcon_hot"></span>
                  <span v-if="data.fanCoil.status === 5" class="eqModeIcon eqModeIcon_fan"></span>
                </div>
              </div>
              <div class="clear itemBot">
                <p class="left">
                  {{ data.sceneName }}
                  <span class="ui-room">{{ data.roomName }}</span>
                </p>
                <div v-if="data.deviceType === 1 && data.airCondition">
                  <p class="right">{{
                      data.airCondition.userRetTemp ? '温度:' + data.airCondition.userRetTemp + '°C' : ''
                    }}</p>
                </div>
                <div v-else-if="data.deviceType ===2 && data.airVentilator">
                  <p class="right">{{
                      data.airVentilator.returnAirTemperature ? '温度:' + data.airVentilator.returnAirTemperature + '°C' : ''
                    }}</p>
                </div>
                <div v-else-if="data.deviceType ===3 && data.fanCoil">
                  <p class="right">{{
                      data.fanCoil.disTemp ? '温度:' + data.fanCoil.disTemp + '°C' : ''
                    }}</p>
                </div>
                <div v-else-if="data.deviceType ===4 && data.detector">
                  <p class="right">{{
                      data.detector.temperature ? '温度:' + data.detector.temperature + '°C' : ''
                    }}</p>
                </div>
                <div v-else-if="data.deviceType ===5 && data.dehumidification">
                  <p class="right">{{
                      data.dehumidification.humidity ? '湿度:' + data.dehumidification.humidity + '%' : ''
                    }}</p>
                </div>

              </div>
            </div>
            <div class="fixedOpt">
              <span class="online" v-if="data.onLine === 1">在线</span>
              <span class="online online_remove" v-else>离线</span>
            </div>
          </div>
        </div>
        <div class="noInfo" v-show="list == '' && list.length == 0">您还没有此类添加智能设备呢</div>
        <div class="text-center moreData" v-show="!more && !(list && list.length == 0)">没有更多数据了...</div>
      </div>

      <!--      </mt-loadmore>-->
    </div>
    <v-menu active="1" :isAlarm="isAlarm"></v-menu>

    <mt-actionsheet :actions="actions" v-model="sheetVisible"></mt-actionsheet>

    <!-- 筛选-->
    <mt-popup v-model="showChoose" class="pubPopup" position="bottom">
      <p class="tipText tip-text-border">筛选</p>
      <mt-picker :slots="chooseList" value-key="name" @change="onValuesChange" ref="mainDegrees"></mt-picker>
      <div class="btns">
        <mt-button size="large" class="btn-orange" @click="sureChoose">确定</mt-button>
        <mt-button size="large" @click="cancelChoose">取消</mt-button>
      </div>
    </mt-popup>

    <!--        关机提示-->
    <div class="tip detail_tip" v-show="closeTip">
      <div class="content">
        <div class="tip_body closeTip_body">
          <div class="modal-warning">
            <span :class="this.closeIcon"></span>
            <p>{{ this.closeText }}</p>
          </div>
        </div>
      </div>
    </div>

    <!--        产品类别-->
    <div class="tip detail_tip" v-show="choosePro">
      <div class="content">
        <div class="tip_con tip_pro_con">
          <p class="tip_pro_name">设备类别</p>
          <ul class="tip_pro_list">
            <li :class="eqType == -1 ? 'active' : ''" @click="chooseProType(-1)">
              全部
              <span class="icon-check"></span>
            </li>
            <li v-for="(item, index) in eqTypeList" :key="index" :class="eqType == item.value ? 'active' : ''"
                @click="chooseProType(item.value)">
              {{ item.name }}
              <span class="icon-check"></span>
            </li>
          </ul>
        </div>
        <div class="tip_foot tip_foot_detail tip_foot_flex">
          <span @click="dropToggleCanel">取消</span>
          <span @click="chooseType()">确定</span>
        </div>
      </div>
    </div>

    <!--        产品场景筛选-->
    <div class="tip detail_tip" v-show="chooseScenVisible">
      <div class="content">
        <div class="tip_con tip_pro_con">
          <p class="tip_pro_name">场景</p>
          <ul class="tip_pro_list">
            <li :class="sceneId == -1 ? 'active' : ''" @click="chooseScen(-1)">
              全部
              <span class="icon-check"></span>
            </li>
            <li v-for="(item, index) in scenList" :key="index" :class="item.id == sceneId ? 'active' : ''"
                @click="chooseScen(item.id)" style="height: 44px;">
              <p class="pText">
                <span>{{ item.name }}</span>
              </p>
              <span class="icon-check"></span>
            </li>
          </ul>
        </div>
        <div class="tip_foot tip_foot_detail tip_foot_flex">
          <span @click="dropScenCancel">取消</span>
          <span @click="eqList(1)">确定</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import menu from '../menu/menu';
import {Toast, Indicator, Actionsheet} from 'mint-ui';
import {PATH} from '../../router/path';

export default {
  name: 'equipment',
  data() {
    return {
      ios: null,
      list: [],
      showDrop: false,
      isAlarm: 0,
      allLoaded: false,
      loading: true, //滚动的初始值，true为不执行滚动加载
      scrollDisable: false, //禁止滑动
      hasNextPage: true, //是否有下一页
      pagInfo: {
        pageNum: 0
      },
      eqType: -1,
      currentEqType: -1,
      showEmpty: false,
      more: true,
      actions: [
        {
          name: '请选择设备类型',
          method: this.showSheet
        },
        {
          name: '新设备',
          method: this.addNew
        },
        {
          name: '已配置过的设备',
          method: this.addOld
        }
      ],
      sheetVisible: false,
      showChoose: false,
      eqTypeList: [
        {
          name: '主机设备',
          value: '1'
        },
        {
          name: '新风设备',
          value: '2'
        },
        {
          name: '温控设备',
          value: '3'
        },
        {
          name: '检测设备',
          value: '4'
        }
      ],
      chooseList: [
        {
          flex: 1,
          values: this.eqTypeList,
          className: 'slot1',
          textAlign: 'center',
          value: 2,
          defaultIndex: 1
        }
      ],
      closeTip: false,
      closeText: '关机中...',
      closeIcon: 'icon-loading-off',
      choosePro: false,
      chooseScenVisible: false,
      scenList: [],
      sceneId: -1,
      currentSceneId: -1
    };
  },
  activated() {
    // this.updatas();
    this.eqList(1)
  },
  mounted() {
    this.closeTimer = null;
    this.getEqRoomList();
  },
  beforeRouteEnter(to, from, next) {
    // Pass a callback to next() to be called after the component is instantiated
    next(vm => {
      // Access Vuex store using vm.$store
      const websocket = vm.$store.state.websocket;
      // Perform any logic after the component is instantiated
      if (websocket) {
        websocket.close();
        vm.$store.state.websocket = null;
      }
    });
  },
  beforeDestroy() {
    Indicator.close();
  },
  components: {
    vMenu: menu
  },
  methods: {
    handleLinkClick() {
      // 阻止事件继续冒泡
      event.stopPropagation();
    },
    dropToggle() {
      this.choosePro = true;
      // this.eqType = this.currentEqType;
    },
    dropToggleCanel() {
      this.choosePro = false;
    },
    dropToggleScen() {
      this.chooseScenVisible = true;
    },
    dropScenCancel() {
      this.chooseScenVisible = false;
    },
    eqList(pageNo) {
      let str = 'pageNo=' + pageNo;
      if (this.eqType != -1) {
        str += '&deviceType=' + this.eqType;
      }
      if (this.sceneId != -1) {

        str += '&sceneId=' + this.sceneId;
      }
      Indicator.open({
        spinnerType: 'fading-circle'
      });
      this.Api.eqList(
          str,
          msg => {
            Indicator.close();
            if (msg.code == 200) {
              this.list = msg.data;
              this.loading = false;
              this.scrollDisable = false;
              this.chooseScenVisible = false;
            }
          },
          () => {
            Indicator.close();
            this.showEmpty = true;
          }
      );
    },
    eqDel(id) {
      let params = {};
      params.id = id;
      this.Api.eqDel(params, function (msg) {
        if (msg.code == 200) {
          let list = this.list;
          list.splice(index, 1);
          this.list = list;
        } else {
          Toast('删除失败');
        }
      });
    },
    chooseProType(type) {
      this.eqType = type;
    },
    chooseType() {
      this.eqList(1);
      this.choosePro = false;
    },

    loadBottom() {
      if (!this.allLoaded) {
        this.more = true;
        this.$refs.loadmore.onBottomLoaded();
      } else {
        this.more = false;
      }
    },

    loadTop() {
      this.$refs.loadmore.onTopLoaded();
    },

    showSheet() {
      this.sheetVisible = true;
    },
    addNew() {
      this.addPos(1);
    },
    addOld() {
      this.addPos(2);
    },
    addPos(type) {
      this.$router.push({
        path: '/equipment/add',
        query: {
          type: type
        }
      });
    },
    onValuesChange() {
    },
    sureChoose() {
    },
    cancelChoose() {
    },
    changOpenVal(data, index) {
      if (data.equipmentStatus == 1) {
        $('.eqItem')
            .eq(index)
            .find('.mint-switch-input')
            .prop('checked', true);
        this.shutDown(data, index);
      }

      if (data.equipmentStatus == 0) {
        $('.eqItem')
            .eq(index)
            .find('.mint-switch-input')
            .prop('checked', false);
        this.startUp(data, index);
      }
    },

    closeInterval(flag) {
      this.closeTip = true;
      let type = '关机';
      this.closeIcon = 'icon-loading-off';
      if (flag == 1) {
        type = '开机';
        this.closeIcon = 'icon-loading-on';
      }
      let time = 10;
      this.closeText = type + '中 ' + time + '秒';
      this.closeTimer = setInterval(() => {
        time--;
        this.closeText = type + '中 ' + time + '秒';
        if (time <= 0) {
          this.closeTip = false;
          clearInterval(this.closeTimer);
          time = 10;
        }
      }, 1000);
    },

    startUp(data, index) {
      let str = 'id=' + data.id;
      let type = data.deviceType;
      this.Api.startUp(str, type, msg => {
        if (msg.code == 200) {
          this.closeInterval(1);
        } else {
          Toast(msg.message);
        }
      });
    },

    shutDown(data, index) {
      let str = 'id=' + data.id;
      let type = data.deviceType;
      this.Api.shutDown(str, type, msg => {
        if (msg.code == 200) {
          this.closeInterval(0);
        } else {
          Toast(msg.message);
        }
      });
    },

    getEqRoomList() {
      let str = '';
      this.Api.useSceneList(str, msg => {
        if (msg.code == 200) {
          this.scenList = msg.data;
        }
      });
    },

    chooseScen(id) {
      this.sceneId = id;
    },

    goDetail(data) {
      let deviceType = data.deviceType;
      // let deviceType = 3;
      let id = data.iotDeviceId;
      if (deviceType === 3) {
        this.$router.push({
          path: PATH.goFanDetail() + id
        });
      } else if (deviceType === 4) {
        this.$router.push({
          path: PATH.goFreshStatus6() + id
        });
      } else if (deviceType === 1) {
        this.$router.push({
          path: PATH.goDetail() + id
        });
      } else if (deviceType === 2) {
        this.$router.push({
          path: PATH.goFreshDetail() + id
        });
      } else {
        this.$router.push({
          path: PATH.goDehumDetail() + id
        })
      }
    }
  }
};
</script>

<style scoped>
@import url('../../assets/list.css');
@import url('./equipment.css');
@import url('../tip/tip.css');
@import url('./detail/detail.css');

.noInfo {
  margin-top: 100px;
}

.list {
  margin-bottom: 55px;
}

.pText {
  width: 80%;
  display: inline-block;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.itemTop {
  min-height: 20px;
}

.loadMoreWrapper {
  padding-bottom: 10px; /* 给底部留出足够空间 */
}

.container {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  min-height: calc(100vh - 160px); /* 动态撑开高度 */
}


.online {
  font-size: 12px;
  color: #3c7cff;
  padding: 0 10px 0 0;
}

.online_remove {
  color: red;
}

.ui-border {
  border-radius: 10px;
}

.ui-room {
  padding-left: 5px;
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/components/equipment/equipment.vue